import ActivityTypeNames from '../../schema/innerSchema/ActivityTypeNames';

/**
 * This function return the activities from the Txp Json blob
 * filter the entities that are TxpActivity type and get the activities array
 */
export default function foundActivities(txpParsedBlob: any): any[] {
    let activities: any[];

    if (txpParsedBlob) {
        activities = txpParsedBlob
            .filter(txpData => txpData.type == ActivityTypeNames.TxpActivity)
            .map(entity => entity.entities);
    }

    return activities[0].length != 0 ? activities[0] : null;
}
